/* eslint-disable react-hooks/exhaustive-deps */
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { prepareHeaders } from "../user/user.api";
import { PaginationResults, TypeQuery } from "../user/user.type";
import { ApiBaseUrl } from "../../http";
import { QueryUrl, useLocationState } from '../../Utils';
import { IPromotion, PromotionFormdata } from './promotion.type';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const PromotionApi = createApi({
    reducerPath: "promotionApi",
    tagTypes: ["promotion"],
    baseQuery: fetchBaseQuery({
        baseUrl: `${ApiBaseUrl}/api/`,
        prepareHeaders,
    }),
    endpoints: (build) => ({
        AddOrUpdatePromotion: build.mutation<
            IPromotion,
            { slug?: string; data: IPromotion | FormData | Partial<IPromotion> }
        >({
            query: ({ slug, data }) => ({
                url: slug ? `promotions/${slug}/` : `promotions/`,
                method: slug ? "PUT" : "POST",
                body: data,
            }),
            invalidatesTags: ["promotion"],
        }),
        getPromotions: build.query<PaginationResults<IPromotion>, TypeQuery>({
            query: (query) => QueryUrl("promotions", query),
            providesTags: ["promotion"],
        }),
        getPromotion: build.query<IPromotion, string>({
            query: (slug) => `promotions/${slug}`,
            providesTags: ["promotion"],
        }),
        deletePromotion: build.mutation<PromotionFormdata, string>({
            query: (slug) => ({
                url: `promotions/${slug}/`,
                method: "DELETE",
            }),
            invalidatesTags: ["promotion"],
        }),
    }),
});

export default PromotionApi

export const {
    useAddOrUpdatePromotionMutation,
    useGetPromotionsQuery,
    useDeletePromotionMutation,
    useLazyGetPromotionQuery
} = PromotionApi;

export function usePromotionFromLocation(): [
    IPromotion,
    boolean,
    string,
    (id: string) => any
] {
    const itemState = useLocationState<IPromotion | undefined>(undefined);
    const [item, setItem] = useState(itemState);
    const { slug } = useParams<{ slug: string }>();
    const [findById, { data, isError, isLoading }] = useLazyGetPromotionQuery();
    const navigate = useNavigate();

    useEffect(() => {
        if (slug) {
            findById(slug);
        }
    }, [slug]);
    useEffect(() => {
        if (isError && !itemState) {
            navigate(-1);
        }
    }, [isError]);
    useEffect(() => {
        if (data) {
            console.log("data", data);
            setItem(data);
        }
    }, [data]);

    return [item as IPromotion, isLoading, slug as string, findById];
}